import { type FC } from "react";
import { Skeleton as ChakraSkeleton, type SkeletonProps as ChakraSkeleteonProps } from "@chakra-ui/react";
import { skeletonTestId } from "./const";

export type SkeletonProps = ChakraSkeleteonProps;
export const Skeleton: FC<SkeletonProps> = (props) => {
  return <ChakraSkeleton data-testid={skeletonTestId} fadeDuration={0.2} speed={0.6} {...props} />;
};
